export const allergensData = [
  {
    allergenId: 1,
    name: {
      de: "(A) Glutenhaltiges Getreide und daraus gewonnene Erzeugnisse",
      en: "(A) Cereals containing gluten: namely wheat (including specific varieties like spelt and Khorasan), rye, barley, oats and their hybridised strains) and products thereof",
    }
  },
  {
    allergenId: 2,
    name: {
      de: "(B) Krebstiere und daraus gewonnene Erzeugnisse",
      en: "(B) Crustaceans and products thereof (for example prawns, lobster, crabs and crayfish)",
    }
  },
  {
    allergenId: 3,
    name: {
      de: "(C) Eier von Geflügel und daraus gewonnene Erzeugnisse",
      en: "(C) Egg and products thereof",
    }
  },
  {
    allergenId: 4,
    name: {
      de: "(D) Fisch und daraus gewonnene Erzeugnisse (ausser Fischgelatine)",
      en: "(D) Fish and products thereof",
    }
  },
  {
    allergenId: 5,
    name: {
      de: "(E) Erdnüsse und daraus gewonnene Erzeugnisse",
      en: "(E) Peanut and products thereof",
    }
  },
  {
    allergenId: 6,
    name: {
      de: "(F) Sojabohnen und daraus gewonnene Erzeugnisse",
      en: "(F) Soybeans and products thereof",
    }
  },
  {
    allergenId: 7,
    name: {
      de: "(G) Milch von Säugetieren und Milcherzeugnisse (inklusive Laktose)",
      en: "(G) Milk and products thereof (including lactose)",
    }
  },
  {
    allergenId: 8,
    name: {
      de: "(H) Schalenfrüchte und daraus gewonnene Erzeugnisse",
      en: "(H) Nuts: namely almond, hazelnut, walnut, cashew, pecan nut, Brazil nut, pistachio nut and Macadamia nut (Queensland nut) and products thereof",
    }
  },
  {
    allergenId: 9,
    name: {
      de: "(L) Sellerie und daraus gewonnene Erzeugnisse",
      en: "(L) Celery and products thereof",
    }
  },
  {
    allergenId: 10,
    name: {
      de: "(M) Senf und daraus gewonnene Erzeugnisse",
      en: "(M) Mustard and products thereof",
    }
  },
  {
    allergenId: 11,
    name: {
      de: "(N) Sesamsamen und daraus gewonnene Erzeugnisse",
      en: "(N) Sesame seeds and products thereof",
    }
  },
  {
    allergenId: 12,
    name: {
      de: "(O) Schwefeldioxid und Sulfite",
      en: "(O) Sulphur dioxide and sulphites",
    }
  },
  {
    allergenId: 13,
    name: {
      de: "(P) Lupinen und daraus gewonnene Erzeugnisse",
      en: "(P) Lupin and products thereof",
    }
  },
  {
    allergenId: 14,
    name: {
      de: "(R) Weichtiere wie Schnecken, Muscheln, Tintenfische und daraus gewonnene Erzeugnisse",
      en: "(R) Molluscs and products thereof (for example clams, oysters, scallops, snails and squid)",
    }
  },
];



// WEBPACK FOOTER //
// ./src/assets/allergens.js